import ModalBootstrap, { ModalProps as BootstrapModalProps } from 'react-bootstrap/Modal';
import { GrPrevious } from '@react-icons/all-files/gr/GrPrevious';
import classNames from 'classnames';

import styles from './Modal.module.scss';

import { Button } from '../Button';
import { Text } from '../Text';

export type BaseModalProps = {
  isOpen?: boolean;
  closeModal?: () => void;
};

export type ModalBtn = {
  onClick?: () => void;
  variant?: string;
  loading?: boolean;
  disabled?: boolean;
  title?: string | React.ReactElement;
  className?: string;
  textClassname?: string;
  testId?: string;
};

export type ModalProps = {
  title?: string | React.ReactElement;
  centered?: boolean;
  renderCustomTitle?: (args: { onClickPrevious?: () => void }) => JSX.Element;
  bodyClassName?: string;
  bodyRef?: React.RefObject<HTMLDivElement>;
  submit?: ModalBtn;
  cancel?: ModalBtn;
  footerClassName?: string;
  onClickPrevious?: () => void;
} & BootstrapModalProps &
  BaseModalProps;

export const Modal: React.FC<ModalProps> = ({
  title,
  renderCustomTitle,
  isOpen,
  children,
  closeModal,
  submit,
  size,
  contentClassName,
  footerClassName,
  centered = true,
  bodyClassName = '',
  bodyRef,
  onClickPrevious,
  cancel,
  ...restModalProps
}) => {
  let renderedTitle: JSX.Element | null = null;

  if (renderCustomTitle) {
    renderedTitle = renderCustomTitle({ onClickPrevious });
  } else if (title) {
    renderedTitle = (
      <ModalBootstrap.Header closeButton className='border-0'>
        {onClickPrevious && <GrPrevious className='cursor-pointer' onClick={onClickPrevious} size={18} />}
        <Text center inline fontWeight='light' color='primary' className='fs-18px absolute-centered-x riforma-regular'>
          {title}
        </Text>
      </ModalBootstrap.Header>
    );
  }

  return (
    <ModalBootstrap
      show={isOpen}
      onHide={closeModal}
      contentClassName={classNames('rounded-3 border-0 bg-light', styles.modal, contentClassName)}
      size={size}
      aria-labelledby='contained-modal-title-vcenter'
      centered={centered}
      fullscreen='md-down'
      {...restModalProps}
    >
      {renderedTitle}
      <ModalBootstrap.Body className={`p-0 ${bodyClassName}`} ref={bodyRef}>
        {children}
      </ModalBootstrap.Body>
      {submit && (
        <ModalBootstrap.Footer className='border-0 px-0 pb-0 m-0'>
          <div className={classNames('w-100', cancel && 'd-flex justify-content-between', footerClassName)}>
            {cancel && (
              <Button
                onClick={cancel.onClick}
                variant={cancel.variant || 'light-outline'}
                loading={cancel.loading}
                className={classNames('w-100 py-3 fs-14px', cancel.className)}
                textClassname={cancel.textClassname}
                disabled={cancel.disabled || cancel.loading}
                data-testid={cancel.testId}
              >
                {cancel.title || 'Cancel'}
              </Button>
            )}
            <Button
              onClick={submit.onClick}
              variant={submit.variant || 'primary'}
              loading={submit.loading}
              className={classNames('w-100 py-3 fs-14px', submit.className)}
              textClassname={submit.textClassname}
              disabled={submit.disabled || submit.loading}
              data-testid={submit.testId}
            >
              {submit.title || 'Submit'}
            </Button>
          </div>
        </ModalBootstrap.Footer>
      )}
    </ModalBootstrap>
  );
};
